import hexColorRegex from "hex-color-regex"

export function isHex(color) {
  return hexColorRegex({ strict: true }).test(color)
}

function cutHex(h) {
  return h.charAt(0) === "#" ? h.substring(1, 7) : h
}

export function hexToR(h) {
  return parseInt(cutHex(h).substring(0, 2), 16)
}
export function hexToG(h) {
  return parseInt(cutHex(h).substring(2, 4), 16)
}
export function hexToB(h) {
  return parseInt(cutHex(h).substring(4, 6), 16)
}

export const hexToRgb = hex => {
  const R = hexToR(hex)
  const G = hexToG(hex)
  const B = hexToB(hex)

  return `${R},${G},${B}`
}
